import { useMemo } from 'react';
import classNames from './MoveStudentsPopup.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentReportItem } from '@/school-management/types/response';
import StudentsTable, {
  convertStudentReportItemToStudentsTableData,
} from './StudentsTableDifferentGrade';
import Button from '@/components/school-management/Button/Button';
import AppIcon from '@/components/school-management/AppIcon/AppIcon';
import { MoveClassDestination } from '@/school-management/types/services/bulk';

interface DifferentGradeProps {
  students: StudentReportItem[];
  classDestination: MoveClassDestination;
  onMoveAll: () => void;
  onMoveSame: () => void;
  onBack: () => void;
}

const DifferentGrade = ({
  students,
  classDestination,
  onMoveAll,
  onMoveSame,
  onBack,
}: DifferentGradeProps) => {
  const { t } = useAdminTranslation();

  const studentsTableData = useMemo(() => {
    return (students || [])
      .filter(s => s.gradeId !== classDestination.gradeId)
      .map(s => convertStudentReportItemToStudentsTableData(s, classDestination, t));
  }, [students, classDestination, t]);

  return (
    <>
      <button
        type='button'
        className={classNames.backButton}
        onClick={onBack}
        aria-label={t('common.back') || 'Back'}
      >
        <AppIcon icon='ArrowLeft' size={20} />
        <span>{t('common.back')}</span>
      </button>
      <div>
        <div className={classNames.title} style={{ fontSize: '26px' }}>
          {t('bulkActions.moveStudents.differentGrade.title')}
        </div>
        <div className={classNames.description}>
          {t('bulkActions.moveStudents.differentGrade.description')}
        </div>
      </div>
      <StudentsTable students={studentsTableData} />
      <div className={classNames.footer}>
        <Button className={classNames.textButton} onClick={onMoveSame}>
          {t('bulkActions.moveStudents.differentGrade.moveSameButton')}
        </Button>
        <Button className={classNames.button} onClick={onMoveAll}>
          {t('bulkActions.moveStudents.differentGrade.moveAllButton')}
        </Button>
      </div>
    </>
  );
};

export default DifferentGrade;
